import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'
import styled from '@emotion/styled'
import './App.scss'
import { theme } from './Theme'
import Inicio from './components/Inicio/Inicio'
import Somos from './components/Somos/Somos'
import Contacto from './components/Contacto/Contacto'
import Clientes from './components/Clientes/Clientes'
import Servicios from './components/Servicios/Servicios'
import Container from '@mui/material/Container'
import NavBar from './components/NavBar/NavBar'
import { Box } from '@mui/material'
import Footer from './components/Footer/Footer'

const AppBox = styled(Box)`
  background-color: #fdf6ec;
  overflow: auto;
  overflow-wrap: break-word;
`
const ContentContainer = styled(Container)`

`

function App() {
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <AppBox id="App-Box">
          <ContentContainer id="Content-Container">
            <NavBar />s
            <Inicio/>
            <Somos />
            <Clientes/>
            <Servicios />
            <Contacto />
            <Footer />
          </ContentContainer>
        </AppBox>
      </ThemeProvider>
    </Router>
  )
}

export default App
